import { cva, type VariantProps } from "class-variance-authority";
import { Button, ButtonProps, buttonVariants } from "../../../button";
import { typographyVariants } from "../../../typography";
import {
  ButtonPayload,
  ButtonPayloadEnum,
} from "@aichat/types/socket/widget.types";

const buttonComponentVariants = cva("", {
  variants: {
    variant: {
      quickReply: buttonVariants({
        size: "sm",
        variant: "outline",
        className: typographyVariants({
          variant: "subtleMedium",
          className:
            "bg-background border border-primary w-fit rounded-full shadow-[0px_1px_2px_0px_#0000000D]",
        }),
      }),
      carouselPrimary: buttonVariants({
        variant: "secondary",
        size: "sm",
      }),
      carouselSecondary: buttonVariants({
        variant: "outline",
        size: "sm",
      }),
      carouselGlobal: buttonVariants({
        variant: "outline",
        size: "sm",
      }),
    },
  },
});

type ButtonComponentProps = Omit<ButtonProps, "variant"> & {
  variant: VariantProps<typeof buttonComponentVariants>["variant"];
  payload?: ButtonPayload;
  linkAsButton?: boolean;
};

function ButtonComponent({
  variant,
  payload,
  linkAsButton,
  ...rest
}: ButtonComponentProps) {
  if (payload?.type === ButtonPayloadEnum.LINK && !linkAsButton) {
    return (
      <a
        target="_blank"
        className="w-full inline"
        href={payload.value || undefined}
        onClick={(e) => {
          if (!payload.value) e.preventDefault();
        }}
      >
        <Button
          {...rest}
          className={buttonComponentVariants({
            variant: variant,
            className: rest.className,
          })}
        />
      </a>
    );
  }

  return (
    <Button
      {...rest}
      onClick={(e) => {
        rest.onClick?.(e);
      }}
      className={buttonComponentVariants({
        variant: variant,
        className: rest.className,
      })}
    />
  );
}

export default ButtonComponent;
